import socket from "socket.io-client";
import eventBus from "./eventBus";

export default () => {
    const io = socket('/');
    console.log('AUTH');
    io.on('message',(data)=>{
        eventBus.$emit('new-log-line',data);
    })
    io.on('end',(data)=>{
        eventBus.$emit('new-log-end',data);
    })
    io.on('error',(data)=>{
        eventBus.$emit('new-log-error',data);
    })

    return io
}